const UserPreferenceKeys = {
  USER_PREFERENCE: "userPreference",
  TIMEZONE_TITLE: "timezoneTitle",
  UPDATE_SUBMIT_SUCCESS_MSG: "updateSubmitSuccessMsg",
  TIMEZONE: "timezone",
  SUPPORT_DST: "supportDST"
}
export default UserPreferenceKeys
